export const CHART_CONFIG = {
  legendPosition: "right",
  showArea: false,
  warningValue: 20,
  dangerValue: 50,
  fixedNum: 2
};
